import React, { useEffect, useState } from "react";

import MainLayout from "../../layouts/MainLayout";

import SideBar from "../../subcomponents/question-options/Sidebar";
import QuestionOption from "../../subcomponents/question-options/QuestionOption";
import Option from "../../subcomponents/question-options/Option";

import DeleteModal from "../../modals/DeleteModal";
import useGetQuestionOptions from "../../../hooks/question-options/useGetQuestionOptions";
import { IQuestionOption } from "../../../types/questionOption";

const QuestionOptions = () => {
  const [currOption, setCurrOption] = useState<number[]>([]);
  const [questionOptions, setQuestionOptions] = useState<IQuestionOption[]>([]);

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  const [isOpenDeleteModalForOption, setIsOpenDeleteModalForOption] = useState<boolean>(false);
  const [isDeleteForOption, setIsDeleteForOption] = useState<boolean>(false);

  useEffect(() => {
    setCurrOption([0]);
  }, []);

  const { data, isPending, isError } = useGetQuestionOptions();

  useEffect(() => {
    if (!isError && !isPending) setQuestionOptions(data);
  }, [data]); //eslint-disable-line

  if (isPending) return <p>Loading...</p>;
  if (isError) return <p>Error!!</p>;
  if (questionOptions.length === 0) return <p>No data found</p>;
  return (
    <MainLayout>
      {isOpenDeleteModal && (
        <DeleteModal
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          setIsDelete={setIsDelete}
          title="Are you sure you?"
          subtitle="This is an irrecoverable action. All data will be lost."
        />
      )}
      {isOpenDeleteModalForOption && (
        <DeleteModal
          setIsOpenDeleteModal={setIsOpenDeleteModalForOption}
          setIsDelete={setIsDeleteForOption}
          title="Are you sure you?"
          subtitle="This is an irrecoverable action. All data will be lost."
        />
      )}
      <div className="imm_quest_admin__main_view">
        <SideBar
          questionOptions={questionOptions}
          setQuestionOptions={setQuestionOptions}
          currOption={currOption}
          setCurrOption={setCurrOption}
        />
        <div className="imm_quest_admin__main_content">
          {currOption.length === 1 && (
            <QuestionOption
              currOption={currOption}
              setCurrOption={setCurrOption}
              questionOptions={questionOptions}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}

            />
          )}
          {currOption.length === 2 && (
            <Option
              currOption={currOption}
              setCurrOption={setCurrOption}
              questionOptions={questionOptions}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
              isDeleteForOption={isDeleteForOption}
              setIsDeleteForOption={setIsDeleteForOption}
              setIsOpenDeleteModalForOption={setIsOpenDeleteModalForOption}
            />
          )}
          {/* {currOption.length === 3 && (
            <Question
              currOption={currOption}
              setCurrOption={setCurrOption}
              sections={sections}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
            />
          )} */}
        </div>
      </div>
    </MainLayout>
  );
};

export default QuestionOptions;
